import { FirebaseFirestore } from "@firebase/firestore-types";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/analytics";
import "firebase/compat/functions";
import "firebase/compat/storage";
import { getFirebaseConfig } from "~/configs/firebase";

let app: firebase.app.App | undefined;

if (!firebase.apps.length) {
  const config = getFirebaseConfig();
  app = firebase.initializeApp(config);

  // if (firebase.analytics.isSupported()) {
  //   firebase.analytics();
  // }
} else {
  app = firebase.app();
}

export const signInOptions = [firebase.auth.EmailAuthProvider.PROVIDER_ID];
export const fieldPath = firebase.firestore.FieldPath;
export const fieldValue = firebase.firestore.FieldValue;
export const auth = firebase.auth();
export const db: FirebaseFirestore = firebase.firestore();
export const functions = firebase.app().functions("asia-northeast1");
export const storage = firebase.storage();

// Use if using firestore emulator
// if (location.hostname === "localhost") {
//   db.useEmulator("localhost", 8080);
// }
